{
    "settings_title": "System settings",
    "branding_title": "Branding",
    "branding_description": "Colours, logos and imagery used across the application, emails, printed tickets and PDF reports.",
    "branding_colours": "Colours",
    "branding_assets": "Logos & imagery",
    "branding_preview": "Preview",
    "branding_upload_hint": "Drag a file here, or click to choose.",
    "branding_remove_asset": "Remove this asset",
    "branding_contrast_ok": "Contrast passes WCAG AA.",
    "branding_contrast_warning": "Contrast is below WCAG AA for body text. Consider a darker colour.",
    "users_title": "Users",
    "users_description": "Staff accounts, roles and data scope.",
    "users_new": "New user",
    "users_edit": "Edit user",
    "users_never_signed_in": "Never signed in",
    "users_last_login": "Last sign-in",
    "users_scope": "Data scope",
    "users_roles": "Roles",
    "users_status": "Status",
    "users_suspend": "Suspend account",
    "users_activate": "Activate account",
    "users_terminate_sessions": "Sign out of all devices",
    "users_effective_permissions": "Effective permissions",
    "users_permission_via": "Granted by {{roles}}",
    "users_permission_direct": "Granted directly",
    "users_suspend_reason": "Why is this account being suspended?",
    "roles_title": "Roles & permissions",
    "roles_description": "What each role may do. Data scope is set per user.",
    "roles_matrix": "Permission matrix",
    "roles_clone": "Clone role",
    "roles_users_count_one": "{{count}} user",
    "roles_users_count_other": "{{count}} users",
    "roles_system": "Built-in role",
    "roles_locked_hint": "This role cannot be edited.",
    "audit_title": "Audit trail",
    "audit_description": "An append-only, hash-chained record of every change. Entries cannot be edited or deleted.",
    "audit_verify": "Verify integrity",
    "audit_verifying": "Verifying…",
    "audit_intact": "Verified intact — {{count}} entries checked.",
    "audit_compromised": "Verification failed. The trail has been modified outside the application.",
    "audit_event": "Event",
    "audit_actor": "Performed by",
    "audit_entity": "Record",
    "audit_changes": "Changes",
    "audit_before": "Before",
    "audit_after": "After",
    "audit_reason": "Reason",
    "audit_no_changes": "No field changes recorded.",
    "audit_auth_events": "Sign-in activity",
    "audit_sensitive": "Sensitive data access",
    "audit_hash": "Entry hash",
    "health_title": "System health",
    "health_ok": "Healthy",
    "health_warning": "Needs attention",
    "health_error": "Failing",
    "health_last_checked": "Checked {{time}}",
    "health_database": "Database",
    "health_queue": "Queue workers",
    "health_scheduler": "Scheduler",
    "health_storage": "File storage",
    "health_audit_trail": "Audit trail",
    "layouts": {
        "title": "Screen layouts",
        "description": "Which panels appear, and in what order, by customer segment and staff role.",
        "presentation_note": "Layouts decide emphasis, not access. Hiding a panel does not restrict anyone — what a user may see is decided by their role and data scope, and is enforced on the server.",
        "empty_title": "No layouts configured",
        "empty_description": "Every screen falls back to its built-in default, shown below.",
        "any_segment": "Any segment",
        "any_role": "Any role",
        "specificity": "Specificity {{score}}",
        "hide_panel": "Hide this panel",
        "show_panel": "Show this panel",
        "remove": "Remove layout",
        "saved": "Screen layout saved.",
        "removed": "Screen layout removed.",
        "defaults_title": "Built-in defaults",
        "defaults_note": "Used when no layout matches. They cannot be deleted, which is what guarantees every screen renders even with this table empty."
    }
}
